import styled from 'styled-components';

export const Container = styled.div`
  width: 120px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
